import React from 'react'
import styles from './Map.module.scss'
import { motion } from "framer-motion"
import DetailMap from '../DetailMap/DetailMap'
import phone from '../../image/Map/phone.svg'
import email from '../../image/Map/email-icon.svg'
import address from '../../image/Map/address.svg'
import time from '../../image/Map/time.svg'
import ButtonBox from '../../components/ButtonBox/ButtonBox'

const titleAnimation = {
    hidden: {
        y: 200,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .5 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .7}
    } 
}


const Map = () => {


    return (
        <motion.section 
            className={styles.main}
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.1, once: true}}
            id='Kontakty'
            >
            <div className={styles.container}>
                <motion.div className={styles.box}>
                    <div className={styles.info}>
                        <motion.h2 className={styles.title} variants={titleAnimation}>Контакты</motion.h2>
                        <motion.div 
                            className={styles.box_contacts}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.05, once: true}}
                            >
                                <img className={styles.icon_contacts} src={phone} alt = 'icon'/>
                                <a className={styles.link_phone}  href="tel:+74957412796" target='_blank' rel='noopener noreferrer'>+7 (495) 741-27-96</a>
                        </motion.div>
                        <motion.div 
                            className={styles.box_contacts}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.05, once: true}}
                            >
                                <img className={styles.icon_contacts} src={phone} alt = 'icon'/>
                                <a className={styles.link_phone}  href="tel:+79637821648" target='_blank' rel='noopener noreferrer'>+7 (963) 782-16-48</a>
                        </motion.div>
                        <motion.div 
                            className={styles.box_contacts}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.05, once: true}}
                            >
                                <img className={styles.icon_contacts} src={email} alt = 'icon'/>
                                <a className={styles.link_email}  href="mailto:workinrussia.pro@yandex.ru" target='_blank' rel='noopener noreferrer'>workinrussia.pro@yandex.ru</a>
                        </motion.div>
                        <motion.div 
                            className={styles.box_contacts}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.05, once: true}}
                            >
                                <img className={styles.icon_contacts} src={address} alt = 'icon'/>
                                <p className={styles.text}>г.Москва, Б.Казенный переулок, дом 5, офис 5</p>
                        </motion.div>
                        <motion.div 
                            className={styles.box_contacts_social}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.05, once: true}}
                            >
                                <img className={styles.icon_contacts} src={time} alt = 'icon'/>
                                <div className={styles.box_time}>
                                    <p className={styles.text}>Пн-ПТ 10:00-19:00 СБ 10:00-17:00</p>
                                </div>
                        </motion.div>
                        <motion.div 
                            className={styles.box_contacts}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.05, once: true}}
                            >
                            <ButtonBox/> 
                        </motion.div>
                    </div>
                    <motion.div 
                        className={styles.box_map}
                        variants={titleAnimation} 
                        initial='hidden'
                        whileInView='visible'
                        viewport={{amount: 0.05, once: true}}
                        >
                        <DetailMap/>
                    </motion.div>
                </motion.div>
            </div>
        </motion.section>
    )
}

export default Map